import { useEffect, useState, type ReactNode } from "react";
import { readUserId } from "../suiteSession";
import { Splash } from "../ui/Splash";

export function AuthGate({ children }: { children: (userId: string) => ReactNode }) {
  const [userId, setUserId] = useState("");

  useEffect(() => {
    const onReady = (ev: Event) => {
      const id = (ev as CustomEvent<{ userId?: string }>).detail?.userId || readUserId();
      setUserId(id);
    };
    const onLost = () => setUserId("");
    window.addEventListener("signAuthReady", onReady);
    window.addEventListener("signAuthLost", onLost);
    if (window.__signSessionVerified) setUserId(readUserId());
    return () => {
      window.removeEventListener("signAuthReady", onReady);
      window.removeEventListener("signAuthLost", onLost);
    };
  }, []);

  useEffect(() => {
    const el = document.getElementById("signSplash");
    if (!el) return;
    if (!userId) {
      el.classList.remove("is-off");
      return;
    }
    const born = (window as Window & { __signBootBorn?: number }).__signBootBorn || Date.now();
    const wait = Math.max(0, 1900 - (Date.now() - born));
    const timer = window.setTimeout(() => el.classList.add("is-off"), wait);
    return () => window.clearTimeout(timer);
  }, [userId]);

  if (!userId) return <Splash sub="Ouverture de la session…" />;
  return <>{children(userId)}</>;
}
